import { combineReducers } from 'redux'

import organisation from './organisation'
import session from './session'
import interactions from './interactions'
import settingsInboxes from './settingsInboxes'
import socket from './socket'
import activities from './activities'
import selected from './selected'
import pauses from './pauses'
import inboxes from './inboxes'
import notifications from './notifications'
import counters from './counters'
import requests from './requests'

export default combineReducers({
  counters,
  organisation,
  interactions,
  inboxes,
  settingsInboxes,
  session,
  socket,
  activities,
  selected,
  pauses,
  notifications,
  requests
})
